import '../assets/module-type-icon.css';

export function ModuleTypeIcon({ managed }: { managed?: boolean }) {
    return <i className={`module-type-icon pi ${managed ? 'pi-file module-type-icon-managed' : 'pi-desktop module-type-icon-unmanaged'}`}
        title={managed ? 'Managed module' : 'Ordinary module'} aria-hidden="true" />;
}
